<template>
    <v-progress-circular
        :rotate="360"
        :size="100"
        :width="10"
        :value="value"
        color="primary"
    >
        <span class="white--text">{{ value }}</span>
    </v-progress-circular>
</template>

<script>

export default {

    name: "CircleLoader",

    props: {
        seconds: {
            type: Number,
            required: false,
            default: 10,
        }
    },

    data() {

        return {
            interval: {},
            value: 0,
            increment: null
        }
    },

    beforeDestroy() {
        clearInterval(this.interval)
    },

    mounted() {

        this.increment = Math.floor(100 / this.seconds);

        this.interval = setInterval(() => {
            if (this.value >= 100) {
                clearInterval(this.interval);
                this.$emit('timeout');
            } else {
                this.value += this.increment
                if (this.value > 100) this.value = 100;
            }

        }, 1000)
    }
}
</script>
